import * as zrender from 'zrender'
let timeout;
export default {
  data() {
    return {
      $instance: null,
      w: 0,
      h: 0,
      arc: [140, 40],
      line_w: 0,
      num: 7,
      pointsGroup: null,
      otherPointsGroup: null,
      pointsGroup2: null,
      otherPointsGroup2: null,
    }
  },
  computed: {
    // 产品资料文件上传数量
    informationNum() {
      return this.spuInfo.informationNum
    },
    // 产品文案文件上传数量
    paperworkNum() {
      return this.spuInfo.paperworkNum
    }
  },
  methods: {
    zrenderInit() {
      setTimeout(() => {
        this.$instance = zrender.init(document.getElementById('zrenderEl'));
        this.w = this.$instance.getWidth();
        this.h = this.$instance.getHeight() - 25;
        this.line_w = this.w - 60;
        // // 线下同款 5
        // if(this.spuInfo.productTypeCode != 5) {
        //   this.drawLine();
        //   setTimeout(_=>{
        //     this.drawPoint();
        //     this.drawOherPoints();
        //     this.drawDesc();
        //     this.renderActive();
        //   },500)
        // }else{
          this.drawLine2();
          setTimeout(_=>{
            this.drawPoint2();
            this.drawOherPoints2();
            this.drawDesc2();
            this.renderActive2();
          },500)
      //   }
      }, 800);
    },
    drawLine2() {
      let h = this.h;
      let num = 7
      // 中间拐弯处区域的宽度，高度
      let arc = this.arc;
      let item_w = this.line_w / (num - 1);
      var g = new zrender.Group();
      const line1 = new zrender.Polyline({
        shape: {
          points: [
            [0*item_w + 30,h/2+10],
            [6*item_w + 30,h/2+10]
          ]
        },
        style: {
          fill: 'transparent',
          stroke: '#e2e2e2'
        }
      })
      const line2 = new zrender.Polyline({
        shape: {
          points: [
            [0*item_w + 30,h/2+10],
            [6*item_w + 30,h/2+10]
          ]
        },
        style: {
          fill: 'transparent',
          stroke: '#e2e2e2'
        }
      })
      const line3 = new zrender.Polyline({
        shape: {
          points: [
            [0*item_w + 30,h/2 - this.arc[1]],
            [1*item_w + 30,h/2 - this.arc[1]],
            [1*item_w + 30,h/2 - 0],
          ]
        },
        style: {
          fill: 'transparent',
          stroke: '#e2e2e2',
          lineDash: [5,5]
        }
      })
      g.add(line1);
      g.add(line2);
      // g.add(line3);虚线
      this.$instance.add(g);
    },
    drawPoint2() {
      // 节点个数
      const num = 7;
      // 起始点x坐标
      const start_coordinate_x = (this.w - this.line_w) / 2;
      // 纵坐标
      const coordinate_y = (this.h / 2) + 10;
      // 两点之间的间隔距离
      let item_w = this.line_w / (num-1);
      var g = new zrender.Group();
      var g2 = new zrender.Group();
      const dot = (x, y) => {
        let tag = new zrender.Circle({
          shape: {
            cx: x,
            cy: y,
            r: 1
          },
          style: {
            fill: '#8D99AE'
          }
        })
        tag.animate('shape', false)
        .when(500, {
          r: 5
        }).start();
        return tag;
      }
      const title = (x, y, text) => {
        return new zrender.Text({
          style: {
            text: text,
            fill: '#999'
          }
        }).attr({
          position: [x - text.length*12/2 ,y+10]
        });
      }
      let texts = ['电商商品专员','品类运营','电商店铺','运营负责人','最终确认','电商商品专员','产品策略部'];
      g.add(dot(0,0));
      g2.add(title(10,0,texts[0]));
      g.add(dot(item_w*1,0));
      g2.add(title(1*item_w,0,texts[1]));
      g.add(dot(2*item_w,0));
      g2.add(title(2*item_w,0,texts[2]));
      g.add(dot(3*item_w,0));
      g2.add(title(3*item_w,0,texts[3]));
      g.add(dot(4*item_w,0));
      g2.add(title(4*item_w,0,texts[4]));
      g.add(dot(5*item_w,0));
      g2.add(title(5*item_w,0,texts[5]));
      g.add(dot(6*item_w,0));
      g2.add(title(6*item_w-10,0,texts[6]));

      g.position[0] = start_coordinate_x;
      g.position[1] = coordinate_y;
      g2.position[0] = start_coordinate_x;
      g2.position[1] = coordinate_y;
      
      this.pointsGroup2 = g;
      this.$instance.add(g);
      this.$instance.add(g2);
    },
    drawOherPoints2() {
      // 节点个数
      const num = 7;
      // 起始点x坐标
      const start_coordinate_x = (this.w - this.line_w) / 2;
      // 纵坐标
      const coordinate_y = (this.h / 2) + 10;
      // 两点之间的间隔距离
      let item_w = this.line_w / (num-1);
      var g = new zrender.Group();
      var g2 = new zrender.Group();
      const dot = (x, y) => {
        let tag = new zrender.Circle({
          shape: {
            cx: x,
            cy: y,
            r: 1
          },
          style: {
            fill: '#8D99AE'
          }
        })
        tag.animate('shape', false)
        .when(500, {
          r: 5
        }).start();
        return tag;
      }
      const title = (x, y, text) => {
        return new zrender.Text({
          style: {
            text: text,
            fill: '#999'
          }
        }).attr({
          position: [x - text.length*12/2 ,y - this.arc[1] + 10]
        });
      }
        
      // g.add(dot(0,-this.arc[1]));
      // g2.add(title(0,0,'产品资料'));

      // g.add(dot(item_w*1,0));
      // g2.add(title(item_w*1,coordinate_y,'产品文案'));

      g.position[0] = start_coordinate_x;
      g.position[1] = coordinate_y;
      g2.position[0] = start_coordinate_x;
      g2.position[1] = coordinate_y;
      
      this.otherPointsGroup2 = g;
      this.$instance.add(g);
      this.$instance.add(g2);
    },
    drawDesc2() {
      // 节点个数
      const num = 7;
      // 起始点x坐标
      const start_coordinate_x = (this.w - this.line_w) / 2;
      // 纵坐标
      const coordinate_y = (this.h / 2) + 10;
      // 两点之间的间隔距离
      let item_w = this.line_w / (num-1);
      var g = new zrender.Group();
      const renderDesc = (x, y, text) => {
        if(!text) return null;
        return new zrender.Text({
          style: {
            text: text,
            fill: '#999'
          }
        }).attr({
          position: [x - text.length*9/2 ,y+25]
        });
      }
      // 开始制作
      let text = this.batchName
      let xnum = 0
      xnum = text.length<5 ? 10 : Math.ceil(this.batchName.length/2.5) * 10
      xnum = text.length<4 ? 0 : Math.ceil(this.batchName.length/2.5) * 10
      g.add(renderDesc(xnum, -this.arc[1]-20, text));
      // // 样品组货
      // // g.add(renderDesc(1*item_w, 0, this.stepDescription['sampleGroup']));
      // // 拍摄
      // // g.add(renderDesc(2*item_w, 0, this.stepDescription['shooting']));
      // // 修片
      // // g.add(renderDesc(3*item_w, this.arc[1], this.stepDescription['retouching']));
      // // 产品资料
      // // g.add(renderDesc(0*item_w, -this.arc[1], '测试'));
      // // 产品文案
      // g.add(renderDesc(1*item_w, 0, '测试'));
      // // 设计
      // g.add(renderDesc(2*item_w, 0, '测试'));
      // // 切片
      // g.add(renderDesc(3*item_w, 0, '测试'));
      // // 准备上架
      // g.add(renderDesc(4*item_w, 0, '测试'));
      // // 完成上架
      // g.add(renderDesc(5*item_w, 0, '测试'));
      
      g.position[0] = start_coordinate_x;
      g.position[1] = coordinate_y;
      
      this.$instance.add(g);
    },
    renderActive2() {
      // let mapNode = {
      //   [this.stepEnum.newArrival]: 0,
      //   [this.stepEnum.design]: 1,
      //   [this.stepEnum.sectioning]: 2,
      //   [this.stepEnum.preparation]: 3,
      //   [this.stepEnum.finished]: 4,
      // }
      // let activeStepIndex = mapNode[this.currentStep]
      let activeStepIndex = this.nodeStatus.processCode ? this.nodeStatus.processCode : this.nodeImgIndex
      
      for(let i = 0; i < activeStepIndex; i++) {
        if(this.nodeStatus.status == '已完成' && this.nodeStatus.processCode == '7') {
          this.pointsGroup2._children[i].attr({
            style: {
              // 走过的节点标绿，正在进行的节点标黄
              fill: '#0BB78E'
            }
          })
        }else {
          this.pointsGroup2._children[i].attr({
            style: {
              // 走过的节点标绿，正在进行的节点标黄
              fill: i < activeStepIndex-1 ? '#0BB78E' : '#FF9F1C'
            }
          })
        }
        
      }
    }
  },
  watch: {
    // activeStepIndex: {
    //   handler(val) {
    //     console.log(val);
    //     if(timeout) clearTimeout(timeout);
    //     let callNow = !timeout;
    //     timeout = setTimeout(_=>{
    //       timeout = null;
    //     },1000);
    //     if(callNow) this.zrenderInit()
    //   },
    //   immediate: true
    // }
  }
}